/* SB · Risengrød-kampagneside: galleri, lightbox, video-pop-up, antal + læg i kurv (temaets kurv-skuffe),
   sticky købsknap når hero-knappen ikke ses, videoslider (træk/swipe/pile/prikker/lyd), dage til jul. */
(function () {
  function init(root) {
    if (root.dataset.rgReady) return;
    root.dataset.rgReady = '1';
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    /* dage til jul */
    var xd = root.getAttribute('data-xmas');
    if (xd) {
      var p = xd.split('-'), t = new Date(+p[0], +p[1] - 1, +p[2]), d = Math.max(0, Math.ceil((t - new Date()) / 864e5));
      $$('[data-rg-days-text]').forEach(function (el) {
        var txt = el.getAttribute('data-rg-days-text');
        el.innerHTML = txt.replace('[d]', '<b>' + d + '</b>');
      });
    }

    /* galleri */
    var slides = $$('[data-rg-slide]'), thumbs = $$('[data-rg-go]');
    function go(i) {
      slides.forEach(function (s) { s.classList.toggle('is-on', +s.getAttribute('data-rg-slide') === i); });
      thumbs.forEach(function (b) { b.setAttribute('aria-current', +b.getAttribute('data-rg-go') === i ? 'true' : 'false'); });
      slides.forEach(function (s) { var v = s.querySelector('video'); if (v) { if (s.classList.contains('is-on')) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } } });
    }
    thumbs.forEach(function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-rg-go')); }); });

    /* lightbox for billeder */
    var lb = $('[data-rg-lb]'), lbImg = $('[data-rg-lb-img]'), imgs = $$('.rg-slide img'), li = 0;
    function big(img) { var ss = (img.getAttribute('srcset') || '').split(',').map(function (x) { return x.trim().split(' ')[0]; }).filter(Boolean); return ss.length ? ss[ss.length - 1] : img.currentSrc || img.src; }
    function lbShow(i) { li = (i + imgs.length) % imgs.length; lbImg.src = big(imgs[li]); lbImg.alt = imgs[li].alt || ''; }
    imgs.forEach(function (img, i) { img.addEventListener('click', function () { lbShow(i); lb.hidden = false; }); });
    if ($('[data-rg-lb-prev]')) $('[data-rg-lb-prev]').addEventListener('click', function () { lbShow(li - 1); });
    if ($('[data-rg-lb-next]')) $('[data-rg-lb-next]').addEventListener('click', function () { lbShow(li + 1); });

    /* video-pop-up */
    var pop = $('[data-rg-popup]');
    $$('[data-rg-pop]').forEach(function (b) { b.addEventListener('click', function () { if (!pop) return; pop.hidden = false; var v = pop.querySelector('video'); if (v) { v.currentTime = 0; v.play().catch(function () {}); } }); });
    function closeAll() { if (pop && !pop.hidden) { pop.hidden = true; var v = pop.querySelector('video'); if (v) v.pause(); } if (lb) lb.hidden = true; }
    $$('[data-rg-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
    [pop, lb].forEach(function (el) { if (el) el.addEventListener('click', function (e) { if (e.target === el) closeAll(); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
      if (lb && !lb.hidden) { if (e.key === 'ArrowLeft') lbShow(li - 1); if (e.key === 'ArrowRight') lbShow(li + 1); }
    });

    /* antal + læg i kurv */
    var qty = 1;
    $$('[data-rg-q]').forEach(function (b) { b.addEventListener('click', function () { qty = Math.max(1, qty + +b.getAttribute('data-rg-q')); $$('[data-rg-qv]').forEach(function (v) { v.textContent = qty; }); }); });
    $$('[data-rg-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant');
        if (!id || btn.disabled) return;
        var routes = (window.FoxTheme && FoxTheme.routes) || {};
        var url = routes.cart_add_url || '/cart/add.js';
        var label = btn.getAttribute('data-label') || btn.textContent;
        btn.setAttribute('data-label', label);
        btn.disabled = true;
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }) })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data.status && data.status >= 400) throw new Error(data.description || 'error');
            btn.classList.add('is-added');
            if (btn.getAttribute('data-added')) btn.textContent = btn.getAttribute('data-added');
            setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; btn.disabled = false; }, 1400);
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          })
          .catch(function () { btn.textContent = label; btn.disabled = false; });
      });
    });

    /* sticky: kun når hero-knappen ikke ses */
    var cta = $('[data-rg-cta]'), stk = $('[data-rg-sticky]');
    if (cta && stk && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { stk.classList.toggle('is-on', !en[0].isIntersecting); }).observe(cta);
    }

    /* videoslider */
    var vs = $('[data-rg-vs-track]');
    if (vs) {
      var cards = Array.prototype.slice.call(vs.children), dots = $('[data-rg-vs-dots]');
      var w = function () { return vs.scrollWidth / Math.max(1, cards.length); };
      if (dots) dots.innerHTML = cards.map(function () { return '<i></i>'; }).join('');
      var mark = function () { var i = Math.round(vs.scrollLeft / w()); if (dots) Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === Math.min(i, cards.length - 1)); }); };
      vs.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true }); mark();
      var wrap = vs.parentNode;
      var fit = function () { var all = vs.scrollWidth <= vs.clientWidth + 2; wrap.classList.toggle('is-static', all); if (dots) dots.hidden = all; };
      fit(); if ('ResizeObserver' in window) new ResizeObserver(fit).observe(vs); else window.addEventListener('resize', fit);
      var pv = $('[data-rg-vs-prev]'), nx = $('[data-rg-vs-next]');
      var stop = function (e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); };
      [pv, nx].forEach(function (b) { if (!b) return; ['pointerdown', 'mousedown', 'touchstart'].forEach(function (t) { b.addEventListener(t, function (e) { e.stopPropagation(); }, true); }); });
      if (pv) pv.addEventListener('click', function (e) { stop(e); vs.scrollBy({ left: -w(), behavior: 'smooth' }); }, true);
      if (nx) nx.addEventListener('click', function (e) { stop(e); vs.scrollBy({ left: w(), behavior: 'smooth' }); }, true);
      var dx = null, sl = 0, moved = 0;
      vs.addEventListener('pointerdown', function (e) { if (wrap.classList.contains('is-static') || e.pointerType === 'touch' || e.target.closest('[data-rg-snd]')) return; dx = e.clientX; sl = vs.scrollLeft; moved = 0; vs.classList.add('is-drag'); vs.setPointerCapture(e.pointerId); });
      vs.addEventListener('pointermove', function (e) { if (dx === null) return; var d = e.clientX - dx; moved = Math.abs(d); vs.scrollLeft = sl - d; });
      var end = function () { if (dx === null) return; dx = null; vs.classList.remove('is-drag'); vs.scrollTo({ left: Math.round(vs.scrollLeft / w()) * w(), behavior: 'smooth' }); };
      vs.addEventListener('pointerup', end); vs.addEventListener('pointercancel', end);
      vs.addEventListener('click', function (e) {
        var b = e.target.closest('[data-rg-snd]'); if (!b) return;
        e.preventDefault(); e.stopPropagation();
        var v = b.parentNode.querySelector('video'); if (!v) return;
        var on = v.muted;
        cards.forEach(function (c) { var o = c.querySelector('video'), s = c.querySelector('[data-rg-snd]'); if (o) o.muted = true; if (s) s.textContent = '🔇'; });
        v.muted = !on; b.textContent = on ? '🔊' : '🔇'; if (on) v.play().catch(function () {});
      });
    }
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-rg]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
